/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Case_Stock_OutInputs */

const vi_station_voice_case_stock_out = /** @type {(inputs: Station_Voice_Case_Stock_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất kho xong`)
};

/**

* @param {Station_Voice_Case_Stock_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_case_stock_out = /** @type {((inputs?: Station_Voice_Case_Stock_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Case_Stock_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_case_stock_out(inputs)
});